import EgwWebIcons from "../../assets/EgwWebFont";

const IdFontRobotoCon = "roboto_con";
const IdFontVolkhovRegular = "volkhov_regular";
export const IdReaderDefaultFont = IdFontRobotoCon;
export const IdReaderDefaultFontEasyApp = IdFontVolkhovRegular;
export const DEF_READER_TEXT_ALIGN = "justify";
export const READER_PLAYER_BEHAVIOURS = {
  ASK: 1,
  HISTORY: 2,
  CURRENT_PARA: 3,
  CONTINUE: 4,
  FIRST_AVAILABLE: 5,
};
export const READER_OPEN_LINK_BEHAVIOUR = {
  openInActiveSplit: "openInActiveSplit",
  openInNewSplit: "openInSplit",
  openInCurrentWindow: "openInWindow",
  openInNewTab: "openInTab",
};

export const MAP_READER_OPEN_LINK_BEHAVIOUR_LABEL = {
  [READER_OPEN_LINK_BEHAVIOUR.openInActiveSplit]: "openInActiveSplit",
  [READER_OPEN_LINK_BEHAVIOUR.openInNewSplit]: "openInNewSplit",
  [READER_OPEN_LINK_BEHAVIOUR.openInCurrentWindow]: "openInWindow",
  [READER_OPEN_LINK_BEHAVIOUR.openInNewTab]: "openInTab",
};

export const CLASS_NAME_EL_ARROW = "reader-arrow";

export const DATA_ATTR_PARA_ID = "data-id";
export const ClassNameReaderPanelScrollbar = "rpc";
export const ClassNameReaderPanel = "rp";

export const CUSTOM_EVENT_TYPE_READER_ACTION = "readerAction";

export const DATA_ATTR_PANEL_INDEX = "data-panel-index";

export const DATA_ATTR_PANEL_ID = "data-panel-id";

export const DATA_ATTR_LINK_ID = "data-link";

// JTL books must open with additional books in reader
export const BooksIdsJTL = [
  "b14345", "b14347",
  "b14372", "b14373", "b14374", "b14375", "b14376",
  "b14377", "b14378", "b14379", "b14380", "b14381"
];

export const BOOKS_IDS_BIBLE_VERSION_DICTIONARIES = [
  "b14175", // KJVSD King James Bible With Strongs Dictionary
  "b14125", // KJRV King James Reference Versio
];

export const BIBLE_TYPE_CONCORDANCES = "bible-concordances";

export const BOOK_REAL_TYPE = {
  bibleVersions: "bible-versions",
  bibleConcordances: "bible-concordances",
  bibleDictionaries: "bible-dictionaries",
  bibleCommentaries: "bible-commentaries",
  bibleSdasi: "bible-sdasi",
};

export const CUSTOM_EVENT_TYPE_READER_PLAY = "handlePlayAudioInReader";

export const fontOptions = [
  {
    label: "Roboto Condensed",
    id: IdFontRobotoCon,
    value: "Roboto Condensed",
    style: { fontFamily: "Roboto Condensed" },
  },
  {
    label: "Roboto",
    id: "roboto",
    value: "Roboto",
    style: { fontFamily: "Roboto" },
  },
  {
    label: "Roboto Slab",
    id: "roboto_slab",
    value: "Roboto Slab",
    style: { fontFamily: "Roboto Slab" },
  },
  {
    label: "Merriweather",
    id: "merriweather",
    value: "Merriweather",
    style: {
      fontFamily: "Merriweather",
      fontStyle: "italic"
    },
  },
  {
    label: "Noto Sans",
    id: "noto_sans",
    value: "Noto Sans",
    style: { fontFamily: "Noto Sans" },
  },
  {
    label: "Noto Sans Condensed",
    id: "noto_sans_cond",
    value: "Noto Sans Condensed",
    style: { fontFamily: "Noto Sans Condensed" },
  },
  {
    label: "Noto Serif",
    id: "noto_serif",
    value: "Noto Serif",
    style: { fontFamily: "Noto Serif" },
  },
  {
    label: "Volkhov Regular",
    id: IdFontVolkhovRegular,
    value: "Volkhov Regular",
    style: { fontFamily: "Volkhov" },
  },
  {
    label: "Volkhov Italic",
    id: "volkhov_italic",
    value: "Volkhov Italic",
    style: {
      fontFamily: "Volkhov",
      fontStyle: "italic"
    },
  },
  {
    label: "Volkhov Bold",
    id: "volkhov_bold",
    value: "Volkhov Bold",
    style: {
      fontFamily: "Volkhov",
      fontWeight: "bold"
    },
  },
];

export const textAlignOptions = [
  {
    id: "left",
    icon: EgwWebIcons["text-left"],
  },
  {
    id: "center",
    icon: EgwWebIcons["text-center"],
  },
  {
    id: "right",
    icon: EgwWebIcons["text-right"],
  },
  {
    id: "justify",
    icon: EgwWebIcons["text-justify"],
  },
];

export const READER_VIEW_CLASS_NAME_PARA_WRAP = "js-para";
export const READER_VIEW_CLASS_NAME_PARA_CONTENT_ONLY = "js-para-content";
